import React, { useContext } from 'react';
import { updateThreshold } from 'flow/store/redux/thunks/thresholdUpdates';
import { createWorkflowHistoryThunk } from 'flow/store/redux/thunks';
import { Operation } from 'flow/service/changelog/types';
import { createUiEffectContext } from 'flow/service/history';
import { changeDescription } from 'flow/store/redux/types';
import { isPreviewAction } from 'flow/service/actions';
import RHSTextField from './RHSTextField';
import { useAppDispatch } from '~/store/reduxHooks';
import { ThresholdContext } from '../context';
import { RuleBuilderContext } from '../../../context';
import { UserContext } from '~/dashboard/context';

interface RHSCreatableProps {
  shouldUseDefaultString: boolean;
}

const RHSCreatable = ({ shouldUseDefaultString }: RHSCreatableProps) => {
  const dispatch = useAppDispatch();
  const { populatedThreshold } = useContext(ThresholdContext);
  const { featureFlags } = useContext(UserContext);
  const { sourceAction } = useContext(RuleBuilderContext);

  const { publicId, right: { attributeValue } } = populatedThreshold;

  const onChange = (newValue: string) => {
    const stateChange = () => dispatch(updateThreshold.rightValue(publicId, newValue));

    dispatch(createWorkflowHistoryThunk(
      stateChange,
      Boolean(featureFlags?.workflowEditorUndoRedo) && !isPreviewAction(sourceAction),
      {
        operation: Operation.Modify,
        uiEffectContext: createUiEffectContext(changeDescription.threshold, {
          publicId,
          actionId: populatedThreshold.actionId,
        }),
      },
    ));
  };

  const values = attributeValue != null ? String(attributeValue).split(',') : [''];

  return (
    <RHSTextField
      onChange={onChange}
      shouldUseDefaultString={shouldUseDefaultString}
      value={values[0]}
    />
  );
};

export default RHSCreatable;

